<template>
  <div class="sidebar-content">
    <el-input prefix-icon="el-icon-search" placeholder="过滤设备" v-model="filterText"></el-input>
    <el-tree
      v-if="sidebarItems"
      class="tree-container"
      empty-text="项目未挂载设备"
      node-key="_id"
      highlight-current
      lazy
      :default-expanded-keys="expandedKeys"
      :current-node-key="currentNodeKey"
      :data="sidebarItems"
      :props="treeProps"
      :filter-node-method="filterNode"
      :load="loadChildren"
      @node-click="clickNode"
      ref="tree"
      :draggable="draggable"
      :allow-drag="allowDrag"
      :allow-drop="allowDrop"
      @node-drop="nodeDrop"
    >
      <div class="tree-context" slot-scope="{ node, data }">
        <span style="line-height:19px;">
          <i class="el-icon-folder" v-if="data.isGroup"></i>
          <i class="el-icon-coordinate" v-else></i>
          <span>{{ node.label }}</span>
        </span>
        <span v-if="data.isGroup && node.label !== '未分组设备'" class="tree-attr">
          <el-button
            type="text"
            size="mini"
            @click.stop="setFreq(data.branchId,data.departmentId)"
            icon="el-icon-setting"
            style="color:#606266;font-size:16px"
          ></el-button>
        </span>
      </div>
    </el-tree>
    <BatchUpdateFreq ref="dialog"></BatchUpdateFreq>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { updateSort } from '@/api';
import BatchUpdateFreq from './BatchUpdateFreq';

export default {
  components: {
    BatchUpdateFreq,
  },
  // inject: ['checkPageReady'],
  data() {
    return {
      sidebarItems: [],
      activeSidebar: '', // 默认激活的侧边栏
      filterText: '',
      treeProps: {
        laebl: 'label',
        children: 'children',
        isLeaf: 'isLeaf',
      },
      currentDevice: null,
      expandedKeys: [],
      currentNodeKey: '',
      isPageReady: false,
    };
  },
  props: {
    device: {
      type: [Object, null],
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('admin', ['currentAdminIsSuper']),
    ...mapState('project', ['currentProject']),
    ...mapState('device', ['devices', 'devicesListUpdatedAt']),
    ...mapState('group', ['branches']),
    ...mapState('menu', ['activeMenu', 'activeSubmenu']),
  },
  watch: {
    activeMenu() {
      this.setSidebarItems();
    },
    activeSubmenu() {
      this.setSidebarItems();
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    branches: {
      handler() {
        this.setSidebarItems();
      },
      deep: true,
    },
    devicesListUpdatedAt() {
      this.setSidebarItems();
    },
    // currentDevice(val) {
    //   if (val && Object.keys(val).length) {
    //     if (this.checkParams()) {
    //       this.setSidebarItems();
    //     }
    //   }
    // }
  },
  created() {
    if (this.device && this.device.id) {
      this.currentNodeKey = `d-${this.device.id}`;
    }
  },
  mounted() {
    this.setSidebarItems();
  },
  methods: {
    async nodeDrop(before, after) {
      let type = '';
      let params = {};
      let sortArr;
      if (after.level === 1) {
        type = 'branches';
        sortArr = after.parent.childNodes.map((item) => {
          return item.data.branchId;
        });
        sortArr.pop();
        params = {
          projectId: this.currentProject.id,
          sortArr,
          type,
        };
      } else if (after.level === 2 && after.data.isGroup) {
        type = 'department';
        sortArr = after.parent.childNodes.map((item) => {
          return item.data.departmentId;
        });
        params = {
          projectId: this.currentProject.id,
          sortArr,
          type,
          BranchId: after.data.branchId,
        };
      } else {
        type = 'device';
        sortArr = after.parent.childNodes.map((item) => {
          return item.data.id;
        });
        if (after.level === 2) {
          params = {
            projectId: this.currentProject.id,
            sortArr,
            type,
            BranchId: after.data.branchId,
          };
        } else {
          params = {
            projectId: this.currentProject.id,
            sortArr,
            type,
            BranchId: after.data.branchId,
            DepartmentId: after.data.departmentId,
          };
        }
      }
      const res = await updateSort(params);
      if (!res.data.code) {
        this.$message.success({ message: '设置成功！' });
        // 处理排序后vuex数据没有对应修改。
        const ids = this.sidebarItems.map(item => item.branchId);
        let arrDevices = this.branches;
        if (after.level === 1) {
          arrDevices = this.branches.sort((a, b) => {
            return ids.indexOf(a.id) - ids.indexOf(b.id);
          });
        }
        this.$emit('nodeDrop', arrDevices);
      } else this.$message.error(res.msg);
    },
    // 只允许一级移动
    allowDrag() {
      return true;
    },
    // 只允许移动到同一级上
    allowDrop(draggingNode, dropNode, type) {
      if ((type === 'next' && dropNode.data.branchId) || type === 'prev') {
        if (
          (draggingNode.level === dropNode.level
            && dropNode.level === 1)
          || (draggingNode.level === dropNode.level
            && dropNode.level === 2
            && draggingNode.data.branchId === dropNode.data.branchId)
          || (draggingNode.level === dropNode.level
            && dropNode.level === 3
            && draggingNode.data.departmentId === dropNode.data.departmentId)
        ) {
          return true;
        }
      }
      return false;
    },
    async setSidebarItems() {
      this.sidebarItems = [];
      const tree = [];
      this.branches.forEach((b) => {
        // 展开节点

        tree.push({
          _id: `b-${b.id}`,
          branchId: b.id,
          label: b.name,
          isGroup: true,
          type: this.activeMenu.id,
        });
      });

      if (this.device && Object.keys(this.device).length) { // 展开设备分组
        if (this.device.BranchId) {
          this.expandedKeys.push(`b-${this.device.BranchId}`);
          this.$store.commit('menu/setCheckGroup', { branchId: this.device.BranchId, label: this.device.laebl });
        } else {
          // 设备没分组
          this.expandedKeys.push('b-0');
          this.$store.commit('menu/setCheckGroup', { branchId: 0, label: '未分组设备' });
        }
        if (this.device.DepartmentId) this.expandedKeys.push(`d-${this.device.DepartmentId}`);
      } else if (tree[0]) { // 没有分组展开第一个
        const { _id, branchId, label } = tree[0];
        if (_id) {
          this.expandedKeys.push(_id);
          this.$store.commit('menu/setCheckGroup', { branchId, label });
          this.$bus.$emit('UPDATE_DEVICE', { branchId, type: this.activeMenu.id });
        }
      }

      if (this.currentAdminIsSuper) {
        const defaultBranch = {
          _id: 'b-0',
          branchId: 0,
          label: '未分组设备',
          isGroup: true,
          type: this.activeMenu.id,
        };
        tree.push(defaultBranch);
      }

      this.sidebarItems = tree;
    },
    // 加载节点数据
    async loadChildren(node, resolve) {
      let children = [];
      const { data, level, parent } = node;

      // 非分组节点直接返回
      const { isGroup } = data;
      if (!isGroup) {
        return resolve([]);
      }

      // 加载一级分组子节点
      if (level === 1) {
        const { branchId } = data; // 一级分组id
        const branch = this.branches.find(b => b.id === branchId);

        // 默认分组没有二级分组
        if (branch && branch.Departments) {
          branch.Departments.forEach((d) => {
            children.push({
              branchId: branch.id,
              departmentId: d.id,
              label: d.name,
              isGroup: true,
              _id: `d-${d.id}`,
            });
          });
        }

        const groupedDevs = await this.loadDevices(branchId, 0);
        groupedDevs.map((item) => {
          return { ...item, _id: `d-${item.id}`, branchId };
        });
        children = [...children, ...groupedDevs];
        // children = children.map((d) => {
        //   Object.assign(d, { _id: `d-${d.id}` });
        //   return d;
        // });
        // const deviceName = this.$route.params.deviceId
        return resolve(children);
      }

      // 加载二级分组子节点
      if (level === 2) {
        const { departmentId } = data;
        const { branchId } = parent.data;
        const groupedDevs = await this.loadDevices(branchId, departmentId);
        children = [...groupedDevs];
        children = children.map((d) => {
          Object.assign(d, { _id: `d-${d.id}`, departmentId, branchId });
          return d;
        });
        return resolve(children);
      }

      return resolve([]);
    },
    // 请求分组下设备
    async loadDevices(branchId, departmentId) {
      let devices = [];
      try {
        if (
          this.currentProject
          && Object.keys(this.currentProject).length
          && this.activeMenu
          && Object.keys(this.activeMenu).length
        ) {
          devices = await this.$store.dispatch('device/fetchGroupedDevices', {
            projectId: this.currentProject.id,
            type: this.activeMenu.id,
            branchId,
            departmentId,
          });
        }
      } catch (err) {
        this.$message.error(err.message);
        return [];
      }

      const leaves = devices.map((device) => {
        const { id, name, holeName } = device;
        const label = holeName || name;
        return { id, name, label, isGroup: false, isLeaf: true, branchId };
      });
      setTimeout(() => {
        this.$bus.$emit('UPDATE_DEVICE', { branchId, type: this.activeMenu.id });
      }, 50);
      return leaves;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    clickNode(obj, node) {
      const device = this.devices.find(d => d.id === obj.id);
      if (device) {
        this.$store.commit('menu/setCurrentDevice', device);
      }
      if (obj.isGroup) {
        this.$store.commit('menu/setCheckGroup', { branchId: obj.branchId, label: obj.label });
        this.$bus.$emit('UPDATE_DEVICE', { branchId: obj.branchId, type: this.activeMenu.id });
      }
      // 二级菜单
      const functionPath = this.$store.state.menu.activeSubmenu
        && this.$store.state.menu.activeSubmenu.subPath;
      // 设备层级，功能按钮 共同符合要求
      if (node.isLeaf && functionPath && device) {
        const sidebarParent = this.$router.options.routes[1].path;
        const path = `${sidebarParent}/${functionPath}/device/${obj.name}`;
        this.$router.push(path);
      }
    },
    setFreq(branchId, departmentId) {
      this.$refs.dialog.show(branchId, departmentId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/variables";

.sidebar-content {
  flex: 1;
  padding: 35px 20px 20px 10px;
  background: $sidebar-background-color;
  .tree-container {
    margin-top: 10px;
    background: $sidebar-background-color;
  }
  .tree-context {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .tree-attr {
    float: right;
    .el-button {
      padding: 0;
    }
  }
}
</style>
